import { useState, useEffect } from 'react';
import { api } from '../services/api';

interface BehandelzonesHeroData {
  id: number;
  attributes: {
    title: string;
    backgroundMedia?: {
      data: {
        id: number;
        attributes: {
          url: string;
          alternativeText?: string;
          width: number;
          height: number;
        };
      };
    };
    mediaType: 'image' | 'video';
    videoUrl?: string;
    overlayOpacity: number;
    textColor: 'white' | 'black';
    paddingBottom: number;
    paddingLeft: number;
    paddingRight: number;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
  };
}

export const useBehandelzonesHero = () => {
  const [data, setData] = useState<BehandelzonesHeroData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchBehandelzonesHero = async () => {
      try {
        setLoading(true);
        const response = await api.get('/behandelzones-hero?populate=*');
        setData(response.data.data);
        setError(null);
      } catch (err: any) {
        // Handle 404 and 500 errors gracefully (endpoint doesn't exist yet or server starting)
        if (err.response?.status === 404 || err.response?.status === 500) {
          console.log('Behandelzones hero endpoint not available yet - this is normal during development');
          setError(null); // Don't show error for 404/500
        } else {
          setError('Failed to fetch behandelzones hero data');
          console.error('Error fetching behandelzones hero:', err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchBehandelzonesHero();
  }, []);

  return { data, loading, error };
}; 